import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

export const StyledVerticalDivider = styled.div`
    margin: 0 ${spaceMixin('xs')};
    width: 1px;
    height: 12px;
    background-color: ${token('colors.blue400')};
`;

export const StyledContactMethodContainer = styled.div`
    max-height: 600px;
    overflow-y: auto;
`;
